import { queryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeLevelApi } from '@/lib/api/common/itemTypeLevel';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const itemTypeLevelQueryOptions = (levelId: number) =>
  queryOptions({
    queryKey: commonQueryKeys.itemTypeLevels.details(levelId),
    queryFn: () =>
      ItemTypeLevelApi.getItemTypeLevel({
        levelId,
      }),
  });

export const useItemTypeLevelQuery = ({
  levelId,
  enabled = true,
}: {
  levelId: number;
  enabled?: boolean;
}) => {
  return useQuery({ ...itemTypeLevelQueryOptions(levelId), enabled });
};
